export enum DialogState {
  Error = 'Error',
  Loading = 'Loading',
  Success = 'Success',
}
